export default preferences => ({
  text: 'Abandoned Cart 1',
  thumbnail:
    'https://vastreach.com/static_assets/email/thumnails/Abandoned_cart.jpg',
  snippets: {
    Button: {
      icon: 'RadioButton',
      text: 'Button',
      editor: 'button',
      html: '<!-- Dynamic WYSIWYG Content --><div style="max-width: 600px;margin: 0 auto 0;padding: 10px 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;"><p style="text-align: center;margin:0;"><a data-button-text="Start now" data-button-url="https://www.vastreach.com" data-button-color="#ffffff" data-button-background-color="#cc6699" href="#" target="_blank"><button style="color: #ffffff; background-color: #cc6699; border: 0; padding: 15px 25px; margin: 0; border-radius: 0.35rem; cursor: pointer;"><strong>View Cart</strong></button></a></p></div><!-- End of Dynamic WYSIWYG Content -->',
    },
    Social: {
      icon: 'Share',
      text: 'Social',
      editor: 'social-media',
      html: '<!-- Dynamic WYSIWYG Content --><table style="margin: 0 auto;" border="0" cellpadding="0" cellspacing="0" width="100%" align="center"><tr><td align="center"><table style="margin: 20px 0 20px 0;"><tr><td align="center"><a data-social-background-color="##cc6699" data-social-media="facebook" href="https://www.facebook.com/"><img src="http://vastreach.com/static_assets/facebook.png" border="0" style="padding: 4px; border-radius: 28px; background-color: #cc6699;" /></a></td><td align="center"><a data-social-background-color="#cc6699" data-social-media="instagram" href="https://www.instagram.com/"><img src="http://vastreach.com/static_assets/instagram.png" border="0" style="padding: 4px; border-radius: 28px; background-color: #cc6699;" /></a></td><td align="center"><a data-social-background-color="#cc6699" data-social-media="twitter" href="https://twitter.com/"><img src="http://vastreach.com/static_assets/twitter.png" border="0" style="padding: 4px; border-radius: 28px; background-color: #cc6699;" /></a></td></tr></table></td></tr></table><!-- End of Dynamic WYSIWYG Content -->',
    },
    Paragraph: {
      icon: 'Notes',
      text: 'Paragraph',
      editor: 'wysiwyg',
      html: `<!-- Dynamic WYSIWYG Content --><div style="max-width: 600px;margin: 0 auto 0;padding: 10px 20px;text-align: center;background: transparent;"> <span style="font-size: medium;color:#000000;font-weight: 500;padding: 0;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">We have over 40 Hot Tubs & Swim Spas on Display from Major Brands and Everything Must Go! Display models are priced to move. Come see for yourself and save. Click below to save even more with a coupon just for you!</span></div><!-- End of Dynamic WYSIWYG Content -->`,
    },
  },
  value: `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">
<html xmlns="http://www.w3.org/1999/xhtml" style="height: 100%;margin: 0;padding: 0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">

<head>
  <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
  <meta name="viewport" content="width=device-width"/>
  <meta class="vastreach-theme" data-vast-theme="abandonedCart"/>
</head>	

<body align="center" style="margin: 0;padding:0; background-color: #ffffff;">
  <div class="background" style="background: #ffffff;">
    <div class="foreground" style="max-width: 600px;background: #ffffff;">
      <table style="max-width: 600px;margin: 0 auto 0;padding: 0;text-align: center;background: transparent;border-spacing: 0;">
        <tr>
          <td class="vastreach-sections" data-vast-editor="img-picker" style="padding: 0;">
            <!-- Dynamic WYSIWYG Content -->
            <div style="max-width: 600px;margin: 0 auto;padding: 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">		
              <img src="${
                preferences?.company_logo_url_blackonwhite ||
                'https://vastreach.com/static_assets/email/abandoned_cart_v1/beta-logo.png'
              }" alt="logo" style="max-width: 300px;margin:20px auto 20px auto;">
            </div>
            <!-- End of Dynamic WYSIWYG Content -->						
          </td>	
        </tr>	

        <tr>	
          <td class="vastreach-sections" data-vast-editor="paragraph">
            <!-- Dynamic WYSIWYG Content -->
            <div style="max-width: 600px;margin: 0 auto;text-align: center;background: #006699;color: #ffffff;padding: 30px 0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">	
              <h1><span style="font-size: xx-large;font-family: Arial, Helvetica, sans-serif;">YOU LEFT YOUR CART FULL</span></h1>
              <strong><span style="font-size: medium;color:#ffffff;padding: 0;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;padding: 0 10px 0 10px;">Would you still like to purchase what was left in your cart?</span></strong>
            </div>
            <!-- End of Dynamic WYSIWYG Content -->						
          </td>	
        </tr>

        <tr>
          <td class="vastreach-sections" data-vast-editor="paragraph" style="padding: 0;">
            <!-- Dynamic WYSIWYG Content -->
            <div style="max-width: 600px;margin: 0 auto 0;padding: 10px 20px;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">        
              <span style="font-size: medium;color:#000000;font-weight: 500;padding: 0;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">We saved your carted item(s) below. If you'd like to continue with your purchase you can view your cart below.</span>
              <br />
              <span style="font-size: medium;color:#000000;font-weight: 500;padding: 0;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">If you have any questions or need a little help, call us at 1-888-000-0000 or email us at email@email.com. We are available 24 hours day, 7 days a week.</span>
            </div>        
            <!-- End of Dynamic WYSIWYG Content -->						
          </td>	
        </tr>

        <tr>
          <td class="vastreach-sections" data-vast-editor="paragraph">
            <!-- Dynamic WYSIWYG Content -->
            <div style="max-width: 600px;margin: 0 auto;padding: 0 20px 0 20px;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">	
              <hr>
            </div>	
            <!-- End of Dynamic WYSIWYG Content -->					  
          </td>									
        </tr>

        <tr>
          <td class="vastreach-sections" data-vast-editor="paragraph" style="padding: 0;">
            <!-- Dynamic WYSIWYG Content -->
            <div style="max-width: 600px;margin: 0 auto;padding: 10px 20px;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">		
              <h2 style="margin: 0;"><span style="font-size: x-large;font-family: Arial, Helvetica, sans-serif;">YOUR CART</span></h2>
            </div>
            <!-- End of Dynamic WYSIWYG Content -->						
          </td>	
        </tr>	

        <tr>
          <td class="vastreach-sections" data-vast-editor="img-picker" style="padding: 0;">
            <!-- Dynamic WYSIWYG Content -->
            <div style="max-width: 600px;margin: 0 auto;padding: 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">	
              <img src="https://vastreach.com/static_assets/email/abandoned_cart_v1/item.jpg" alt="woman in black dress" style="max-width: 100%;margin: 0 auto;display: block;">
            </div>
            <!-- End of Dynamic WYSIWYG Content -->						
          </td>	
        </tr>	

        <tr>
          <td class="vastreach-sections" data-vast-editor="paragraph" style="padding: 0;">
            <!-- Dynamic WYSIWYG Content -->
            <div style="max-width: 600px;margin: 0 auto;padding: 10px 20px;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">		
              <strong>
                <span style="font-size: medium;padding: 0;margin:0;font-family: Arial, Helvetica, sans-serif;">
                    Slim Dress (Black)
                    </br>
                    $125.00
                </span>
              </strong>
            </div>
            <!-- End of Dynamic WYSIWYG Content -->						
          </td>	
        </tr>	

        <tr>
          <td class="vastreach-sections" data-vast-editor="button" style="padding: 0;">
            <!-- Dynamic WYSIWYG Content -->
            <div style="max-width: 600px;margin: 0 auto 0;padding: 10px 0;text-align: center;background:transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">
              <p style="text-align: center;margin:0;">
                  <a data-button-text="Start now" data-button-url="https://www.vastreach.com" data-button-color="#ffffff" data-button-background-color="#cc6699" href="#" target="_blank">
                      <button style="color: #ffffff; background-color: #cc6699; border: 0; padding: 15px 25px; margin: 0; border-radius: 0.35rem; cursor: pointer;"><strong>View Cart</strong></button>
                  </a>
              </p>
            </div>
            <!-- End of Dynamic WYSIWYG Content -->						
          </td>	
        </tr>		  

        <tr>	
          <td class="vastreach-sections" data-vast-editor="paragraph">
            <!-- Dynamic WYSIWYG Content -->
            <div style="max-width: 600px;margin: 0 auto;text-align: center;background: #006699;color: #ffffff;padding: 30px 0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">	
              <h1 style="font-size: xx-large;">MORE SALES TO COME!</h1>
              <strong><span style="font-size: medium;color:#ffffff;padding: 0;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;padding: 0 10px 0 10px;">Visit us at www.fancyclothing.com for more deals</span></strong>
            </div>        
            <!-- End of Dynamic WYSIWYG Content -->						
          </td>	
        </tr>					
      </table>  		
    </div>	
  </div>	
</body>	
</html>`,
})
